module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e7348"
    }
  }, [_c('big', [_vm._v("Contents")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _vm._m(86), _vm._v(" "), _vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _vm._v(" "), _vm._m(90), _vm._v(" "), _vm._m(91), _vm._v(" "), _vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95), _vm._v(" "), _vm._m(96), _vm._v(" "), _vm._m(97), _vm._v(" "), _vm._m(98), _vm._v(" "), _vm._m(99), _vm._v(" "), _vm._m(100), _vm._v(" "), _vm._m(101), _vm._v(" "), _vm._m(102), _vm._v(" "), _vm._m(103), _vm._v(" "), _vm._m(104), _vm._v(" "), _vm._m(105), _vm._v(" "), _vm._m(106), _vm._v(" "), _vm._m(107), _vm._v(" "), _vm._m(108), _vm._v(" "), _vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _vm._m(111), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _vm._m(114), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _vm._m(117), _vm._v(" "), _vm._m(118), _vm._v(" "), _vm._m(119), _vm._v(" "), _vm._m(120), _vm._v(" "), _vm._m(121), _vm._v(" "), _vm._m(122), _vm._v(" "), _vm._m(123), _vm._v(" "), _vm._m(124), _vm._v(" "), _vm._m(125), _vm._v(" "), _vm._m(126), _vm._v(" "), _vm._m(127), _vm._v(" "), _vm._m(128), _vm._v(" "), _vm._m(129), _vm._v(" "), _vm._m(130), _vm._v(" "), _vm._m(131), _vm._v(" "), _vm._m(132), _vm._v(" "), _vm._m(133), _vm._v(" "), _vm._m(134), _vm._v(" "), _vm._m(135), _vm._v(" "), _vm._m(136), _vm._v(" "), _vm._m(137), _vm._v(" "), _vm._m(138), _vm._v(" "), _vm._m(139), _vm._v(" "), _vm._m(140), _vm._v(" "), _vm._m(141), _vm._v(" "), _vm._m(142), _vm._v(" "), _vm._m(143), _vm._v(" "), _vm._m(144), _vm._v(" "), _vm._m(145), _vm._v(" "), _vm._m(146), _vm._v(" "), _vm._m(147), _vm._v(" "), _vm._m(148), _vm._v(" "), _vm._m(149), _vm._v(" "), _vm._m(150), _vm._v(" "), _vm._m(151)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7398"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c9_r1#d7e205413",
      "id": "d14e329"
    }
  }, [_c('b', [_vm._v("Top Ten Quotes about Hinduism ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7448"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c10_r1#d7e221914",
      "id": "Anch00314"
    }
  }, [_c('b', [_vm._v("Introduction ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7498"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c11_r1#d7e244516",
      "id": "Anch00516"
    }
  }, [_c('b', [_vm._v("1 The Goal of Living: Hinduism and the Four Aims of Life ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7568"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c11_r1#d7e250217",
      "id": "d14e341"
    }
  }, [_vm._v("The Dutiful Way to Live ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0038"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c11_r1#d7e262017",
      "id": "d14e344"
    }
  }, [_vm._v("Why Dharma Is the Principal End ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0048"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c11_r1#d7e289719",
      "id": "d14e347"
    }
  }, [_vm._v("Artha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0058"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c11_r1#d7e303620",
      "id": "d14e350"
    }
  }, [_vm._v("Kama ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0068"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c11_r1#d7e333622",
      "id": "d14e353"
    }
  }, [_vm._v("Dharma ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0078"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c11_r1#d7e341523",
      "id": "d14e356"
    }
  }, [_vm._v("Moksha ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8068"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e353024",
      "id": "Anch00724"
    }
  }, [_c('b', [_vm._v("2 Paths to Uniting with God")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e811068"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e357925",
      "id": "d14e364"
    }
  }, [_vm._v("Yoga ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0088"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e372826",
      "id": "d14e367"
    }
  }, [_vm._v("Yoga over Time ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e385826",
      "id": "d14e370"
    }
  }, [_vm._v("Patanjali and the Yoga Sutras ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0098"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e486733",
      "id": "d14e373"
    }
  }, [_vm._v("Raja Yoga: Mental and Spiritual Development ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e549637",
      "id": "d14e376"
    }
  }, [_vm._v("Jnana Yoga: The Way to God Through Knowledge ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e565938",
      "id": "d14e379"
    }
  }, [_vm._v("Bhakti Yoga: The Path to God Through Love ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e612940",
      "id": "d14e382"
    }
  }, [_vm._v("Karma Yoga: The Way to God Through Work ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0148"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c12_r1#d7e630041",
      "id": "d14e385"
    }
  }, [_vm._v("Yoga Today ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8828"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c13_r1#d7e680044",
      "id": "Anch00945",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 Hinduism: History and Central Ideas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2586828"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c13_r1#d7e683745",
      "id": "d14e392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evolution of Hindu Thought ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0158"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c13_r1#d7e698146",
      "id": "d14e396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Philosophy and Feel for Hinduism ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0168"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c13_r1#d7e724447",
      "id": "d14e399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Images of Hinduism ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0188"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c13_r1#d7e741648",
      "id": "d14e402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A History of Ancient India Before the Aryan Migration ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0178"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c13_r1#d7e784051",
      "id": "d14e405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aryan India ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0198"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c13_r1#d7e802552",
      "id": "d14e408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aryan Religion: Gateway to the Vedas ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9348"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c14_r1#d7e820254",
      "id": "Anch01154",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 Ancient Scriptures: The Vedas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e93146548"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c14_r1#d7e827055",
      "id": "d14e415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vedas ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0208"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c14_r1#d7e843255",
      "id": "d14e418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Four Vedas ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0218"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c14_r1#d7e867157",
      "id": "d14e421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creation in the Vedas ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0228"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c14_r1#d7e879157",
      "id": "d14e424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Yajur Veda, the Sama Veda, and the Atharva Veda ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0238"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c14_r1#d7e917459",
      "id": "d14e427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gods of the Rig Veda ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9888"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c15_r1#d7e955762",
      "id": "Anch01362",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5 Ancient Scriptures: The Upanishads")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e98522388"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c15_r1#d7e960763",
      "id": "d14e435",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vedanta: The End of the Vedas ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0248"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c15_r1#d7e1002465",
      "id": "d14e438",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of the Upanishads ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0258"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c15_r1#d7e1025867",
      "id": "d14e441",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Separateness Is an Illusion ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0268"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c15_r1#d7e1054769",
      "id": "d14e444",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Is Brahman ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0278"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c15_r1#d7e1067869",
      "id": "d14e447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Spiritual Illness ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10309"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c16_r1#d7e1073872",
      "id": "Anch01562",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6 Central Concepts of Hinduism: Karma and Samsara")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1034409"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c16_r1#d7e1081373",
      "id": "d14e454",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karma ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0289"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c16_r1#d7e1091473",
      "id": "d14e457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karma and Good Qualities ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0299"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c16_r1#d7e1112975",
      "id": "d14e460",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samsara")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t02112299"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c16_r1#d7e1132476",
      "id": "d14e463",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karma and Dharma ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10719"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1143978",
      "id": "Anch01778",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7 Hinduism Creates Jainism")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10777819"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1153179",
      "id": "d14e471",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jainism Carving Its Own Path")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0369"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1181280",
      "id": "d14e474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Amazing Mahavira ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0309"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1230583",
      "id": "d14e477",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem and Solution of Living")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0319"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1244784",
      "id": "d14e480",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Five Vows of Jainism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0329"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1338090",
      "id": "d14e483",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World and Its Inhabitants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0339"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1366892",
      "id": "d14e486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jain Division")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0349"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c17_r1#d7e1387793",
      "id": "d14e489",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Jains in Our Time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e11389"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e1415396",
      "id": "Anch01996",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8 Another Offshoot of Hinduism: Buddhism")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1188849"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e1419397",
      "id": "d14e496",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buddhism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0379"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e1434098",
      "id": "d14e499",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Siddhartha Gautama")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0449"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e1451299",
      "id": "d14e503",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Youth of Luxury and Pleasure")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0389"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e14822101",
      "id": "d14e506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding the Path: The Renunciation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0399"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e15043102",
      "id": "d14e509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Five Ascetics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0409"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e15201103",
      "id": "d14e512",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enlightenment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0419"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e15455105",
      "id": "d14e515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Buddhist Moral Code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0429"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c18_r1#d7e15714106",
      "id": "d14e518",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buddha’s Developed Moral Doctrine")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e12059"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c19_r1#d7e16070110",
      "id": "Anch021110",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9 The Bhagavad Gita")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1205659"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c19_r1#d7e16157111",
      "id": "d14e525",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bhagavad Gita on Duty")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0459"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c19_r1#d7e16636113",
      "id": "d14e528",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bhagavad Gita View of Reality")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0469"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c19_r1#d7e17074116",
      "id": "d14e531",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Krishna’s Philosophy of Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0479"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c19_r1#d7e17576119",
      "id": "d14e534",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Control: The Dharma of the Ideal Man")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0489"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c19_r1#d7e17911121",
      "id": "d14e538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spiritual Outlook of the Bhagavad Gita")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e12699"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c20_r1#d7e18131124",
      "id": "Anch023124",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10 Hindu Metaphysics: What Exists")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e125239"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c20_r1#d7e18183125",
      "id": "d14e545",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brahman")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0509"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c20_r1#d7e18406126",
      "id": "d14e548",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knowing Brahman")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0519"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c20_r1#d7e18594127",
      "id": "d14e551",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brahma")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0529"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c20_r1#d7e18731128",
      "id": "d14e554",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hiranyagarbha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0539"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c20_r1#d7e18859129",
      "id": "d14e557",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ishvara: The Creative Spirit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e13159"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c21_r1#d7e19018132",
      "id": "Anch025132",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11 Hindu Epistemology")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e13125659"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c21_r1#d7e19069133",
      "id": "d14e564",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Do We Know What Exists?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0569"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c21_r1#d7e19129133",
      "id": "d14e567",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lower Stage of Knowledge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0579"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c21_r1#d7e20155140",
      "id": "d14e570",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dreaming State: Taijasa, the Second State of Consciousness")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0589"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c21_r1#d7e20331141",
      "id": "d14e574",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deep Sleep State: Prajna, the Third State of Consciousness")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0599"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c21_r1#d7e20387141",
      "id": "d14e577",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Superconscious State: Turiya, the Fourth State of Consciousness")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e137010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c22_r1#d7e21197148",
      "id": "Anch027148",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12 Philosophy and Theology")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e12255537010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c22_r1#d7e21293149",
      "id": "d14e584",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nyaya, or Analysis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c22_r1#d7e21540150",
      "id": "d14e587",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vaishesika System")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c22_r1#d7e21737151",
      "id": "d14e590",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sankhya")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t05446110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c22_r1#d7e21877152",
      "id": "d14e593",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yoga")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06210"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c22_r1#d7e22177153",
      "id": "d14e596",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mimamsa, or Enquiry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06310"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c22_r1#d7e22364154",
      "id": "d14e599",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vedanta, or the End of the Vedas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e142710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e22481156",
      "id": "Anch029156",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13 Shankara and Other Important Thinkers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1427784410"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e22545157",
      "id": "d14e606",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Importance of Shankara")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06510"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e22729157",
      "id": "d14e610",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shankara’s Life")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06610"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e22884158",
      "id": "d14e613",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advaita, or Nondualism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e22963159",
      "id": "d14e616",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysticism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06810"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e23331161",
      "id": "d14e619",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shankaracharya Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t06910"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e23500162",
      "id": "d14e622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramanuja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07510"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c23_r1#d7e23685163",
      "id": "d14e625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madhva")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e149810"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e23884166",
      "id": "Anch031166",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14 What Morality Consists of: The Four Castes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e149814510"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e23934167",
      "id": "d14e632",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Caste System")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e24227168",
      "id": "d14e635",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brahmins: The Priests")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07210"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e24333169",
      "id": "d14e638",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kshatriyas: The Kings and Warriors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07310"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e24566170",
      "id": "d14e641",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vaishyas: The Commoners ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07410"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e24602171",
      "id": "d14e645",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shudras: The Servants ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07254310"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e24651171",
      "id": "d14e648",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Untouchables ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t075542310"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e24861172",
      "id": "d14e651",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Caste System Today: Is It Still Practiced as Much?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08310"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c24_r1#d7e25115174",
      "id": "d14e654",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rejecting the Caste System: The Sikhs ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e15447710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c25_r1#d7e25240176",
      "id": "Anch033176",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15 Life’s Four Stages")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1571162710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c25_r1#d7e25277177",
      "id": "d14e661",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dharma ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e15711442710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c25_r1#d7e25376177",
      "id": "d14e664",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brahmacharya ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1571122710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c25_r1#d7e25468178",
      "id": "d14e667",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Householders ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e15711271110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c25_r1#d7e25631179",
      "id": "d14e670",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retirement ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e161310"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e25694180",
      "id": "Anch035180",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("16 Important Thinkers of the Last Three Centuries")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e16154878310"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e25757181",
      "id": "d14e677",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysticism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07610"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e25941182",
      "id": "d14e681",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramprasad Sen (1718–1775)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e26117183",
      "id": "d14e684",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sri Ramakrishna (1836–1886)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07810"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e26559186",
      "id": "d14e687",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raja Rammohun Roy (1772–1833)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t07910"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e26914188",
      "id": "d14e690",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rabindranath Tagore (1861–1941)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e27218190",
      "id": "d14e693",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sri Aurobindo (1872–1950)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c26_r1#d7e27820193",
      "id": "d14e696",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sarvepalli Radhakrishnan (1888–1975)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e169710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c27_r1#d7e28061196",
      "id": "Anch037196",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("17 The Life and Thoughts of Mohandas K. Gandhi (1869–1948)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1125469710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c27_r1#d7e28108197",
      "id": "d14e703",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Concept of Nonviolence")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08410"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c27_r1#d7e28280198",
      "id": "d14e706",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gandhi’s Life")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08510"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c27_r1#d7e28649200",
      "id": "d14e709",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Method of Nonviolence Is Born")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08610"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c27_r1#d7e29150204",
      "id": "d14e712",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Economic Pressure Against the British")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08710"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c27_r1#d7e29359205",
      "id": "d14e716",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quit India Movement and Independence from Britain ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e174711"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c28_r1#d7e29573208",
      "id": "Anch039208",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("18 Other Disciples of Civil Disobedience and Nonviolence")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1747112511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c28_r1#d7e29613209",
      "id": "d14e723",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Socrates")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c28_r1#d7e29951211",
      "id": "d14e726",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martin Luther")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09211"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c28_r1#d7e30371214",
      "id": "d14e729",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry David Thoreau and Civil Disobedience")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t08911"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c28_r1#d7e30924218",
      "id": "d14e732",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leo Tolstoy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c28_r1#d7e31261220",
      "id": "d14e735",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martin Luther King Jr.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e172569611"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c29_r1#d7e31791226",
      "id": "Anch041226",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("19 Hindu Ideas in Popular Culture")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e179611"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c29_r1#d7e31871227",
      "id": "d14e742",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transcendental Meditation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c29_r1#d7e32753232",
      "id": "d14e745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quiet Beatle and Hinduism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09411"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c29_r1#d7e33551237",
      "id": "d14e748",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beatles and Meditation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c29_r1#d7e33966239",
      "id": "d14e752",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hare Krishnas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09611"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c29_r1#d7e34571242",
      "id": "d14e755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vedic Astrology")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e184311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e35498248",
      "id": "Anch043248",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("20 Controversies about Hinduism")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e184314511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e35540249",
      "id": "d14e762",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Specific Misconceptions and Truths about Hinduism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e18431422511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e35824251",
      "id": "d14e765",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Practicing Yoga Heretical for Christians?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e184315874511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e35920251",
      "id": "d14e768",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hinduism and Contemporary Science")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e36427254",
      "id": "d14e771",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hindu Tolerance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t09911"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e36664256",
      "id": "d14e774",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is There Hindu Extremism?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e37022258",
      "id": "d14e777",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hinduism in Southeast Asia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e37241259",
      "id": "d14e780",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monastic Hindus")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c30_r1#d7e37486260",
      "id": "d14e783",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hindu Attitudes about Suicide")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e191311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c31_r1#d7e37647262",
      "id": "Anch045262",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("21 Rituals and Practices: Hindu Marriage, Funerals, Food, and Vegetarianism")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t125460311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c31_r1#d7e37703263",
      "id": "d14e791",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage Selection Criteria")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10411"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c31_r1#d7e37916264",
      "id": "d14e794",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Marriage Ceremony")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c31_r1#d7e38141265",
      "id": "d14e797",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Funeral Ritual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10611"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c31_r1#d7e38302266",
      "id": "d14e800",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food in Hinduism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e195111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c32_r1#d7e39122272",
      "id": "Anch047272",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("22 How to Find a Hindu Spiritual Leader")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t1057796311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c32_r1#d7e39178273",
      "id": "d14e807",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Training")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10711"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c32_r1#d7e39298273",
      "id": "d14e810",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Qualities of a Spiritual Leader")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c32_r1#d7e39490274",
      "id": "d14e813",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritual Pilgrimage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t10911"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c32_r1#d7e39732275",
      "id": "d14e816",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacraments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e198411"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Anth_9781605507507_epub_c33_r1#d7e39983278",
      "id": "Anch049278",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix: Further Reading")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1676dd16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anth_9781605507507_epub_c7_r1.vue
// module id = 78
// module chunks = 0